<template>
  <div>
    <br />
    <h1 class="text-xs-center">Advanced: Realtime Operations Diagnostics</h1>

    <system-health-banner
      :title="globalTitle"
      :subtitle="globalSubtitle"
      :status="globalStatus"
      :last-updated-label="lastUpdatedLabel"
    >
      <template slot="actions">
        <v-btn
          icon
          :disabled="apiInProgress"
          :loading="apiInProgress"
          @click="refreshAll({ silent: false })"
        >
          <v-icon>fal fa-sync</v-icon>
        </v-btn>
        <v-switch
          v-model="autoPollEnabled"
          label="Auto refresh (15s)"
          hide-details
          class="ml-2 d-inline-flex"
        />
      </template>
    </system-health-banner>

    <v-tabs icons-and-text v-model="activeTab">
      <v-tabs-slider color="primary" />
      <v-tab ripple href="#overview">
        Overview
        <v-icon>fal fa-th-large</v-icon>
      </v-tab>
      <v-tab ripple href="#progressive-transportation">
        Progressive Transportation
        <v-icon>fal fa-users</v-icon>
      </v-tab>
      <v-tab ripple href="#pricing">
        Pricing Loop
        <v-icon>fal fa-ticket-alt</v-icon>
      </v-tab>
      <v-tab ripple href="#map-api">
        Map API Workers
        <v-icon>fal fa-map-marked-alt</v-icon>
      </v-tab>
      <v-tab ripple href="#scheduled-jobs">
        Scheduled Jobs
        <v-icon>fal fa-business-time</v-icon>
      </v-tab>

      <v-tabs-items v-model="activeTab">
        <v-tab-item value="overview">
          <overview-tab
            :api-overview="apiOverview"
            :map-api-overview="mapApiOverview"
            @navigate-tab="onNavigateTab"
          />
        </v-tab-item>
        <v-tab-item value="progressive-transportation">
          <boarding-pipeline-tab
            :refresh-token="refreshToken"
            :silent-refresh="silentRefresh"
          />
        </v-tab-item>
        <v-tab-item value="pricing">
          <pricing-loop-tab
            :refresh-token="refreshToken"
            :silent-refresh="silentRefresh"
            @navigate-map-api="onNavigateTab('map-api')"
          />
        </v-tab-item>
        <v-tab-item value="map-api">
          <map-api-workers-tab
            :refresh-token="refreshToken"
            :silent-refresh="silentRefresh"
          />
        </v-tab-item>
        <v-tab-item value="scheduled-jobs">
          <scheduled-jobs-tab
            :refresh-token="refreshToken"
            :silent-refresh="silentRefresh"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import src from './src'

export default src
</script>
